import React from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux'

import store from './store'
import App from "./components/App";
import './i18n';
import "./assets/scss/index.scss";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
